<div class="main-container-btn">
    <app-assistance-out-hours *ngIf="!showAssistanceCallBtn"></app-assistance-out-hours>
    <app-assistance-in-hours *ngIf="showAssistanceCallBtn" [procedureType]="procedureType"></app-assistance-in-hours>
</div>